import './list/list';
import './list/list-accommodation';
import './list/list-localities';